const isDevelopment = process.env.REACT_APP_STAGE === "development"
const isStaging = process.env.REACT_APP_STAGE === "staging"
const isProduction = process.env.REACT_APP_STAGE === "production"
const isQAProduction = process.env.REACT_APP_STAGE === "qaproduction"

function partnerDefaultEnterpriseId() {
  if (isDevelopment) {
    return process.env.REACT_APP_REFERRALS_DEFAULT_ENTERPRISE_ID_DEV
  }
  if (isStaging) {
    return process.env.REACT_APP_REFERRALS_DEFAULT_ENTERPRISE_ID_STAGE
  }
  if (isQAProduction) {
    return process.env.REACT_APP_REFERRALS_DEFAULT_ENTERPRISE_ID_QAPROD
  }
  if (isProduction) {
    return process.env.REACT_APP_REFERRALS_DEFAULT_ENTERPRISE_ID_PROD
  }
  return process.env.REACT_APP_REFERRALS_DEFAULT_ENTERPRISE_ID_DEV
}

function partnerDefaultOrganizationType() {
  return process.env.REACT_APP_REFERRALS_DEFAULT_ORGANIZATION_TYPE
}

export { partnerDefaultEnterpriseId, partnerDefaultOrganizationType }
